module.exports = __webpack_public_path__ + "img/12培训服务.2668ec16.png";